export default "__VITE_ASSET__BKJIlsx6__"